export const ROLES = {
    OWNER: "Owner",
    MANAGER: "Manager",
    USER: "User"
}